import http from '../http'

const logout = async () => http.post('/sessao/logout')

export default {
  logout,
}
